"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PREVIOUS_PAGE = exports.NEXT_PAGE = exports.MAX_BUTTONS_MOBILE = exports.MAX_BUTTONS_DESKTOP = exports.ELLIPSES = void 0;
exports.generateButtonArray = generateButtonArray;
var MAX_BUTTONS_DESKTOP = exports.MAX_BUTTONS_DESKTOP = 9;
var MAX_BUTTONS_MOBILE = exports.MAX_BUTTONS_MOBILE = 4;
var PREVIOUS_PAGE = exports.PREVIOUS_PAGE = 'Previous Page';
var NEXT_PAGE = exports.NEXT_PAGE = 'Next Page';
var ELLIPSES = exports.ELLIPSES = '...';
function replaceUrlParam(url, newValue) {
  var paramName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'page';
  var urlObject = url && url.length && new URL(url);
  var hasParam = urlObject && urlObject.searchParams.has(paramName);
  if (hasParam) {
    // eslint-disable-next-line eqeqeq
    if (newValue == '1') urlObject.searchParams["delete"](paramName);else urlObject.searchParams.set(paramName, newValue);
    return urlObject.toString();
  }
  return url;
}

/* Generates an array of button labels corresponding to the page numbers.
        Sets the 1st element to page number 1, and the last element to the final page number.
        If not consecutive, sets the ellipses at position 2 and last-but-one. 
        Also adds the chevrons at the start and end positons. */
function generateButtonArray(_ref) {
  var currentPage = _ref.currentPage,
    maxPages = _ref.maxPages,
    maxButtons = _ref.maxButtons,
    isMobile = _ref.isMobile,
    _ref$seoUrl = _ref.seoUrl,
    seoUrl = _ref$seoUrl === void 0 ? '' : _ref$seoUrl;
  var isSeoUrl = seoUrl && seoUrl.length;
  var separator = isSeoUrl && seoUrl.includes('?') ? '&' : '?';
  var url = isSeoUrl && "".concat(seoUrl).concat(separator, "page");
  var buttons = [{
    label: "".concat(currentPage),
    href: replaceUrlParam(url, currentPage)
  }];

  /* eslint-disable-next-line no-plusplus */
  for (var i = 0; i < maxButtons; i++) {
    var newPage = Number(buttons[0].label) - 1;
    if (newPage > 0) {
      buttons.unshift({
        label: "".concat(newPage),
        href: replaceUrlParam(url, newPage)
      });
      if (buttons.length === maxButtons) break;
    }
    newPage = Number(buttons[buttons.length - 1].label) + 1;
    if (newPage < maxPages + 1) {
      buttons.push({
        label: "".concat(newPage),
        href: replaceUrlParam(url, newPage)
      });
      if (buttons.length === maxButtons) break;
    }
  }

  // Set the first button to page 1 and the last button to last page number
  buttons[0] = {
    label: '1',
    href: replaceUrlParam(url, '1')
  };
  buttons[buttons.length - 1] = {
    label: "".concat(maxPages),
    href: replaceUrlParam(url, maxPages)
  };

  // Set ellipses if button numbers are not consecutive
  if (buttons.length > 1 && maxPages > MAX_BUTTONS_MOBILE) {
    if (buttons[1].label !== '2' && buttons[1].label !== "".concat(currentPage) || isMobile && currentPage > 2) {
      buttons[1] = {
        label: "".concat(ELLIPSES, "Start"),
        href: undefined
      };
    }
    if (buttons[buttons.length - 2].label !== "".concat(maxPages - 1) && buttons[buttons.length - 2].label !== "".concat(currentPage) || isMobile && currentPage < maxPages - 1) {
      buttons[buttons.length - 2] = {
        label: "".concat(ELLIPSES, "End"),
        href: undefined
      };
    }
    var hasCurrentPage = buttons.some(function (_ref2) {
      var label = _ref2.label;
      return label === "".concat(currentPage);
    });
    // Current page may have been overwritten on mobile by the ellipses, so re-insert it.
    if (isMobile && !hasCurrentPage) {
      buttons.splice(2, 0, {
        label: "".concat(currentPage),
        href: replaceUrlParam(url, currentPage)
      });
    }
  }
  var prevPageUrl = function () {
    if (seoUrl && seoUrl.length) {
      if (currentPage === 1) return undefined;
      return replaceUrlParam(url, currentPage - 1);
    }
    return undefined;
  }();
  var nextPageUrl = function () {
    if (seoUrl && seoUrl.length) {
      if (maxPages === currentPage) return undefined;
      if (maxPages > currentPage) return replaceUrlParam(url, currentPage + 1);
      return seoUrl;
    }
    return undefined;
  }();
  return {
    pages: buttons,
    prevPageUrl: prevPageUrl,
    nextPageUrl: nextPageUrl
  };
}